var mySwiper = new Swiper('.carousel__cta', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 0,
  breakpoints: {
    // when window width is >= 480px
    768: {
      spaceBetween: 40
    }
  },
  navigation: {
    nextEl: '.activity-featured__pagination .swiper-button-next',
    prevEl: '.activity-featured__pagination .swiper-button-prev'
  },
  pagination: {
    el: '.activity-featured__pagination .swiper-pagination',
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return '<span class="' + className + '"> 0' + (index + 1) + '</span>';
    }
  }
});